/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { HTTPValidationError, OrganizationProfileResponse } from './platformapi.schemas';

import getOrganizationByIdMutator from '../custom-axios-instance';

/**
 * @summary Get Organization By Id
 */
export const getOrganizationById = (orgId: number, signal?: AbortSignal) => {
  return getOrganizationByIdMutator<OrganizationProfileResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/directory_organizations/${orgId}`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationByIdQueryKey = (orgId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/directory_organizations/${orgId}`] as const;
};

export const getGetOrganizationByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationById>>,
  TError = void | HTTPValidationError,
>(
  orgId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationByIdQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationById>>> = ({ signal }) =>
    getOrganizationById(orgId, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationById>>
>;
export type GetOrganizationByIdQueryError = void | HTTPValidationError;

export function useGetOrganizationById<
  TData = Awaited<ReturnType<typeof getOrganizationById>>,
  TError = void | HTTPValidationError,
>(
  orgId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationById>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationById<
  TData = Awaited<ReturnType<typeof getOrganizationById>>,
  TError = void | HTTPValidationError,
>(
  orgId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationById>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationById<
  TData = Awaited<ReturnType<typeof getOrganizationById>>,
  TError = void | HTTPValidationError,
>(
  orgId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Organization By Id
 */

export function useGetOrganizationById<
  TData = Awaited<ReturnType<typeof getOrganizationById>>,
  TError = void | HTTPValidationError,
>(
  orgId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationByIdQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
